/**
 * Checks if the given wallet is an ecosystem wallet.
 *
 * @param {string} walletId - The wallet ID to check.
 * @returns {boolean} True if the wallet is an ecosystem wallet, false otherwise.
 * @internal
 */
export function isEcosystemWallet(wallet) {
    return typeof wallet === "string"
        ? wallet.startsWith("ecosystem.")
        : wallet.id.startsWith("ecosystem.");
}
//# sourceMappingURL=is-ecosystem-wallet.js.map